// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__erAW5","overflowing":"ReadFullNote_overflowing__1DLf3"};